/**
 * Copyright 2025 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
export const MOBILE_FIXED_HEADER_HEIGHT = 64;

export const TABLET_FIXED_HEADER_HEIGHT = 67;

export const DESKTOP_FIXED_HEADER_HEIGHT = 80;
